export default "__VITE_PUBLIC_ASSET__9ecf6c6c__"